import { render, staticRenderFns } from "./BoxSelection.vue?vue&type=template&id=2040e8d8&"
import script from "./BoxSelection.vue?vue&type=script&lang=js&"
export * from "./BoxSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports